import { Injectable } from '@angular/core';

import { Observable, forkJoin } from 'rxjs';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import * as lodash from 'lodash';

export class PlycaTranslateHttpLoader extends TranslateHttpLoader {
  private adaptTranslateHttpLoader: TranslateHttpLoader;
  private primeTranslateHttpLoader: TranslateHttpLoader;

  constructor(http: HttpClient, prefix: string, suffix: string) {
    super(http, prefix, suffix);
    const adaptPrefix = prefix.endsWith('/')
      ? prefix + 'adapt/'
      : prefix + '/adapt/';
    this.adaptTranslateHttpLoader = new TranslateHttpLoader(
      http,
      adaptPrefix,
      suffix
    );
    const primeprefix = prefix.endsWith('/')
      ? prefix + 'primeng/'
      : prefix + '/primeng/';
    this.primeTranslateHttpLoader = new TranslateHttpLoader(
      http,
      primeprefix,
      '_prime' + suffix
    );
  }

  getTranslation(lang: string): Observable<any> {
    let productTranslationObs = super.getTranslation(lang);
    let adaptTranslationObs = this.adaptTranslateHttpLoader.getTranslation(lang);
    let primeTranslationObs = this.primeTranslateHttpLoader.getTranslation(lang);
    return forkJoin([primeTranslationObs, productTranslationObs, adaptTranslationObs]).pipe(
      map(([primei18n, productI18n, adapti18n]) => lodash.merge(lodash.merge(primei18n, productI18n), adapti18n))
    );
  }
}
